// extracted by mini-css-extract-plugin
export var buttons = "_aw-0";
export var buttonsActive = "_aw-h";
export var cancelConfirm = "_aw-1";
export var closeButton = "_aw-2";
export var column = "_aw-3";
export var container = "_aw-4";
export var detailHeader = "_aw-6";
export var detailTitle = "_aw-7";
export var detailsContent = "_aw-5";
export var header = "_aw-8";
export var headerWithClose = "_aw-9";
export var icon = "_aw-a";
export var infoIcon = "_aw-c";
export var informationContainer = "_aw-b";
export var sideDrawer = "_aw-d";
export var sideDrawerOpen = "_aw-e";
export var stickyFooter = "_aw-f";
export var typeOption = "_aw-g";